import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from './api';
import Swal from 'sweetalert2';

function Horarios() {
    const [horarios, setHorarios] = useState([]);
    const [docentes, setDocentes] = useState([]);
    const [dias, setDias] = useState([]);
    const [periodos, setPeriodos] = useState([]);
    const [form, setForm] = useState({ id_docente: '', dia_semana: '', per_id: [] });
    const [docenteFiltro, setDocenteFiltro] = useState('');

    useEffect(() => {
        fetchHorarios();
        fetchDocentes();
        fetchDias();
        fetchPeriodos();
    }, []);

    const fetchHorarios = async () => {
        const res = await api.get('/horarios');
        console.log(res.data);

        setHorarios(res.data);
    };

    const fetchDocentes = async () => {
        const res = await api.get('/docentes');
        setDocentes(res.data);
    };

    const fetchDias = async () => {
        const res = await api.get('/dias');
        setDias(res.data);
    };

    const fetchPeriodos = async () => {
        const res = await api.get('/periodos');
        setPeriodos(res.data);
    };

    const handleChange = (e) => {
        const { name, value, options, type } = e.target;
        if (type === 'select-multiple') {
            const selectedValues = [];
            for (let i = 0; i < options.length; i++) {
                if (options[i].selected) selectedValues.push(options[i].value);
            }
            setForm({ ...form, [name]: selectedValues });
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const saveHorario = async () => {
        if (!form.id_docente || !form.dia_semana || form.per_id.length === 0) return;

        try {
            for (const perId of form.per_id) {
                await api.post('/horarios', {
                    id_docente: form.id_docente,
                    dia_semana: form.dia_semana,
                    per_id: perId,
                });
            }

            setForm({ id_docente: '', dia_semana: '', per_id: [] });
            fetchHorarios();

            Swal.fire({
                icon: 'success',
                title: '¡Guardado!',
                text: 'Los horarios fueron registrados correctamente.',
                timer: 2000,
                showConfirmButton: false,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar los horarios.',
            });
        }
    };

    const deleteHorario = async (id) => {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Esta acción no se puede deshacer!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/horarios/${id}`);
                fetchHorarios();
                Swal.fire('¡Eliminado!', 'El horario ha sido eliminado.', 'success');
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el horario.', 'error');
            }
        }
    };

    const horariosFiltrados = docenteFiltro
        ? horarios.filter((h) => h.Docente?.id == docenteFiltro)
        : horarios;

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>🕒 Gestión de Horarios</h2>

            <div style={styles.formContainer}>
                <select
                    name="id_docente"
                    value={form.id_docente}
                    onChange={handleChange}
                    style={styles.select}
                >
                    <option value="">Seleccione un docente</option>
                    {docentes.map((d) => (
                        <option key={d.id} value={d.id}>
                            {d.nombres} {d.apellido_paterno}
                        </option>
                    ))}
                </select>

                <select
                    name="dia_semana"
                    value={form.dia_semana}
                    onChange={handleChange}
                    style={styles.select}
                >
                    <option value="">Seleccione un día</option>
                    {dias.map((d) => (
                        <option key={d.dia_id} value={d.dia_id}>
                            {d.dia_detalle}
                        </option>
                    ))}
                </select>

                <select
                    name="per_id"
                    multiple
                    value={form.per_id}
                    onChange={handleChange}
                    style={styles.selectMultiple}
                >
                    {periodos.map((p) => (
                        <option key={p.per_id} value={p.per_id}>
                            {p.per_detalle}
                        </option>
                    ))}
                </select>

                <button onClick={saveHorario} style={styles.button}>
                    Agregar
                </button>
            </div>
            <div style={{ margin: '10px 0' }}>
                <label>Filtrar por docente: </label>
                <select
                    value={docenteFiltro}
                    onChange={(e) => setDocenteFiltro(e.target.value)}
                    style={{ marginLeft: '10px' }}
                >
                    <option value="">Todos</option>
                    {docentes.map((d) => (
                        <option key={d.id} value={d.id}>
                            {d.nombres} {d.apellido_paterno}
                        </option>
                    ))}
                </select>
            </div>
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>Docente</th>
                        <th style={styles.th}>Día</th>
                        <th style={styles.th}>Período</th>
                        <th style={styles.th}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {horariosFiltrados.map((h) => (
                        <tr key={h.id} style={styles.tr}>
                            <td style={styles.td}>
                                {h.Docente?.nombres} {h.Docente?.apellido_paterno}
                            </td>
                            <td style={styles.td}>{h.Dia?.dia_detalle}</td>
                            <td style={styles.td}>{h.Periodo?.per_detalle}</td>
                            <td style={styles.td}>
                                <button
                                    onClick={() => deleteHorario(h.id)}
                                    style={styles.deleteButton}
                                >
                                    Eliminar
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: '900px',
        margin: '40px auto',
        padding: '20px',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgb(0 0 0 / 0.1)',
    },
    title: {
        textAlign: 'center',
        color: '#333',
    },
    formContainer: {
        display: 'flex',
        gap: '15px',
        marginBottom: '25px',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    select: {
        padding: '8px 12px',
        fontSize: '16px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        minWidth: '180px',
    },
    selectMultiple: {
        padding: '8px 12px',
        fontSize: '16px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        minWidth: '220px',
        height: '120px',
    },
    button: {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        padding: '10px 20px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '16px',
        alignSelf: 'center',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        boxShadow: '0 2px 8px rgb(0 0 0 / 0.1)',
    },
    th: {
        padding: '12px 15px',
        backgroundColor: '#007bff',
        color: 'white',
        textAlign: 'left',
    },
    tr: {
        borderBottom: '1px solid #ddd',
    },
    td: {
        padding: '10px 15px',
        fontSize: '15px',
        color: '#555',
    },
    deleteButton: {
        backgroundColor: '#dc3545',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontWeight: '600',
    },
};

export default Horarios;
